// FIXME: Refacto me:
// - Convert me to ES6 js

// Section specific scripts come here
// TODO refacto into single logic
// desktop version
import {
  clearSelectOptions,
  initSelectOptions,
  colorizeHeadersBgColor,
  colorizeFeaturesBgColor
} from '@sections/toggle/section';

export const displayStickyDesktop = function () {
  const comparePlanSection = $('.alt-page:not(.hidden) .compare-plans-v3-section').first();
  const stickyDesktop = comparePlanSection.find('.sticky-header-desktop');
  const top = $(document).scrollTop();
  if (comparePlanSection.length > 0) {
    const start_dist = comparePlanSection.offset().top + 70;
    const stickyHeaderHeight = stickyDesktop.outerHeight();
    const end_dist = comparePlanSection.offset().top + comparePlanSection.outerHeight() - stickyHeaderHeight;
    if (top < end_dist && top > start_dist) {
      stickyDesktop.removeClass('hidden');
    } else {
      stickyDesktop.addClass('hidden');
    }
  }
};

export const displayStickyMobile = () => {
  const comparePlanSection = $('.alt-page:not(.hidden) .compare-plans-v3-section').first();
  const stickyMobile = $('.header-sticky-compare-plan-mobile-table');
  const stickyHeaderHeight = stickyMobile.outerHeight();
  const top = $(document).scrollTop();

  if (comparePlanSection.length > 0) {
    const start_dist = comparePlanSection.offset().top + 90;
    const end_dist = comparePlanSection.offset().top + comparePlanSection.outerHeight() - stickyHeaderHeight / 2;
    if (top < end_dist && top > start_dist) {
      if (stickyMobile.hasClass('hidden')) {
        stickyMobile.removeClass('hidden');
        initSelectOptions();
      }
    } else {
      if (!stickyMobile.hasClass('hidden')) {
        stickyMobile.addClass('hidden');
      }
    };
  }
};

document.addEventListener('DOMContentLoaded', function (event) {
  displayStickyDesktop();
  document.addEventListener('scroll', displayStickyDesktop);
});

// mobile version
document.addEventListener('DOMContentLoaded', function (_event) {
  colorizeHeadersBgColor();
  colorizeFeaturesBgColor();
  displayStickyMobile();
  document.addEventListener('scroll', displayStickyMobile);
  $('a[href=\'#compare-plan\']').on('click', function () {
    scrollToActiveComparePlanSectionHandler();
  });
});

// Section specific scripts come here
const comparePlanV3Hash = '#compare-plan';

// Building a selector dynamicly
// We target .compare-plans-v3-section
// that are prsent into
// .base-page or .alt-page that are not hidden
const pageSelectors = ['.base-page', '.alt-page:not(.hidden)'];
for (let i = 0; i < pageSelectors.length; i += 1) {
  pageSelectors[i] = pageSelectors[i] + ' .compare-plans-v3-section';
}
const comparePlansSectionSelector = pageSelectors[0] + ', ' + pageSelectors[1];

const getActiveCompareElem = function () {
  const candidates = $(comparePlansSectionSelector);
  return candidates.first();
};

// Callback handler
const scrollToActiveComparePlanSectionHandler = function () {
  if (window.location.hash != comparePlanV3Hash) { return; }

  const elem = getActiveCompareElem();

  // FIXME: Handle static 88px;
  const topScroll = elem.offset().top - 88;
  $([document.documentElement, document.body]).animate(
    { scrollTop: topScroll },
    300
  );
};

// Trigger hashChanged on document to
let storedHash = window.location.hash;
window.setInterval(function () {
  if (window.location.hash != storedHash) {
    storedHash = window.location.hash;
    $(document).trigger('hashChanged', { value: storedHash });
  }
}, 100);

$('.compare-plans-v3-section').on('init-section', scrollToActiveComparePlanSectionHandler);
$(document).on('hashChanged', scrollToActiveComparePlanSectionHandler);

if ($('.compare-plans-v3-section').length) {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('sm-overview') == 3) {
    setTimeout(function () {
      $('.select-table:visible:last').empty().append($('.comparable:visible:first').data('options'));
      $('.select-table:visible:last').prop('selectedIndex', 2).change();
      $('.select-table:visible:first').empty().append($('.comparable:visible:first').data('options'));
      $('.select-table:visible:first').prop('selectedIndex', 1).change();
    }, 800);
  }
}

document.addEventListener('DOMContentLoaded', function (_event) {
  // TODO: Add smooth effect on rotation and hidden here.
  const hideComparePlanV3AccordionContent = (parentEl, accordion) => {
    if (accordion.hasClass('hidden')) {
      accordion.removeClass('hidden');
      parentEl.find('.icon-arrow-down').addClass('transform rotate-180');
    } else {
      accordion.addClass('hidden');
      parentEl.find('.icon-arrow-down').removeClass('transform rotate-180');
    }
  };

  const titles = document.querySelectorAll('.accordion-title-js');

  titles.forEach((title) => {
    title.addEventListener('click', function () {
      const parent = $(this.closest('.accordion-item'));
      const currentAccordion = $(parent.find('.accordion-item-content'));

      if (parent.length > 0) {
        hideComparePlanV3AccordionContent(parent, currentAccordion);
      };

      const arrow = parent.find('.icon-arrow-down');
      currentAccordion.toggleClass('open');
      arrow.toggleClass('up');
    });
  });
});
